'use client';

import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

import { BOOSTED_TEXT_ANY_LOCALE } from '@/constants/boostedListings';
import { shouldUserSeeBoostedListings } from '@/modules/boostedListings/helpers';
import { useProductBySlugBasic } from '@/modules/product/hooks/useProductBySlugBasic';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  slug: string;
};

export function BoostedTag({ slug }: Props) {
  const { data: product } = useProductBySlugBasic(slug);
  const [, user] = useCurrentUser();

  const displayBoostedListingsForUser = shouldUserSeeBoostedListings(
    user?.date_joined
  );

  const isOwnProduct = user?.id === product?.seller.id;

  if (!product?.is_boosted || !displayBoostedListingsForUser || !isOwnProduct) {
    return null;
  }

  return (
    <Caption variant="lg-bold" className={styles.boostedText}>
      {BOOSTED_TEXT_ANY_LOCALE}
    </Caption>
  );
}
